import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 9815CAC2-7390-4AE1-AE72-2B49546987EC
 * name step-backward-2
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/step-backward-2.svg
 * tags
 */
export const StepBackward2Icon = createSvgIcon(<><path d="M17,5H14V19H17V5M12,5L1,12L12,19V5M22,5H19V19H22V5Z" /></>, 'StepBackward2Icon');
export default StepBackward2Icon